import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import DiscussionThread from "components/Common/Discussion";
import ReponseCard from "components/Common/ReponseCard";
import RequestCard from "components/Common/RequestCard";
import AuditCard from "components/Common/SectionCard";
import SouscriptionFinaliseesListHm from "components/Common/SouscriptionFinaliseesListHm";
import InvestissementListHm from "components/Common/InvestissementListHm";
import Config from "config";
const TicketDetail = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [wait, setWait] = useState(1000);
  const toggle = () => setModal(!modal);
  const [data, setData] = useState("");
  const [userData, setUserData] = useState([]);

  const [btnsecondary1, setBtnsecondary1] = useState(false);

  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const [selectedFichier, setSelectedFichier] = useState("");
  const handleCancel = async (action) => {
    toast.info("Cancelling ...");
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/${action.controlleur}/${id}/${action.action}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const donnee = await response.json();
      if (response.status == 200) {
        toast.success(donnee.message);
        setReponseSuccess("Envoyé");
      } else {
        throw new Error(
          "La requête a échoué avec le statut " + response.status
        );
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleFichierChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    console.log(newFile);
    if (newFile) {
      setSelectedFichier(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const [reponse, setReponse] = useState("");
  const [reponseSuccess, setReponseSuccess] = useState("");
  const handleReponseChange = (e) => {
    setReponse(e.target.value);
  };
  const handleReponseSubmit = async (event) => {
    event.preventDefault();

    try {
      const formData = new FormData();

      formData.append("message", reponse);
      formData.append("fichier", selectedFichier);

      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_tickets/${id}/new_message`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        toast.success(responseData.message);
        setTimeout(() => {
          setReponseSuccess("Envoyé");
        }, 2000);
      } else {
        console.error("Post request failed");
        const responseData = await response.json();

        if (responseData) {
          toast.error(responseData.error);
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Tickets | DETAILS";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={{ ...(type_compte == "client" ? navStyleClient : navStyle) }}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {!loading ? (
              "Détails Ticket"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  const handleDropDownActionsClick = async (action) => {
    switch (action.action) {
      case "reopening":
        toast.info("Réouverture en cours ...");
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/${action.controlleur}/${id}/${action.action}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const donnee = await response.json();
          if (response.status == 200) {
            toast.success(donnee.message);
            setTimeout(() => {
              setReponseSuccess("Envoyé");
            }, 2000);
          } else {
            throw new Error(
              "La requête a échoué avec le statut " + response.status
            );
          }
        } catch (error) {
          toast.error(error.message);
        }
        break;

      case "waiting_validation":
        toast.info("En attente de validation...");
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/${action.controlleur}/${id}/${action.action}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const donnee = await response.json();
          if (response.status == 200) {
            toast.success(donnee.message);
            setTimeout(() => {
              setReponseSuccess("Envoyé");
            }, 2000);
          } else {
            throw new Error(
              "La requête a échoué avec le statut " + response.status
            );
          }
        } catch (error) {
          toast.error("Echec de changement de statut");
          toast.error(error.message);
        }
        break;
      case "accepting":
        toast.info("Accepting ...");
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/${action.controlleur}/${id}/${action.action}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const donnee = await response.json();
          if (response.status == 200) {
            toast.success(donnee.message);
            setTimeout(() => {
              setReponseSuccess("Envoyé");
            }, 2000);
          } else {
            throw new Error(
              "La requête a échoué avec le statut " + response.status
            );
          }
        } catch (error) {
          toast.error("Echec  switch session ");
          toast.error(error.message);
        }
        break;
      case "cancelling":
        toggle();
        setData(action);

        break;
      default:
        toast.error("Aucune action configurée");
        break;
    }
  };
  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_tickets/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const userData = await response.json();
        setUserData(userData);
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, [reponseSuccess]);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  const handleGoBack = () => {
    window.history.back(); // Cela vous ramènera en arrière dans l'historique du navigateur
  };
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  return (
    <React.Fragment>
      <div>
        {/* <Button color="danger" onClick={toggle}>
          Supprimer
        </Button> */}
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>Confirmation</ModalHeader>
          <ModalBody>
            Êtes-vous sûr de vouloir supprimer ce document ?
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => handleCancel(data)}>
              Oui
            </Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Annuler
            </Button>
          </ModalFooter>
        </Modal>
      </div>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/fx_tickets/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Tickets
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        userData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {userData.can_edit ? (
                        <Link
                          to={`${backUrl}/fx_tickets/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {userData.can_destroy ? (
                        <Link to="#!" className="btn btn-sm btn-danger">
                          <i className="bx bx-trash-alt"></i>Supprimer
                        </Link>
                      ) : null}
                      {userData?.actions?.length > 0 ? (
                        <>
                          <>
                            &nbsp; &nbsp;
                            <Dropdown
                              isOpen={btnsecondary1}
                              toggle={() => setBtnsecondary1(!btnsecondary1)}
                            >
                              <DropdownToggle
                                tag="button"
                                className="btn btn-sm btn-secondary"
                              >
                                Actions <i className="mdi mdi-chevron-down" />
                              </DropdownToggle>
                              <DropdownMenu>
                                {userData?.actions.map((value, index) => (
                                  <>
                                    <DropdownItem
                                      onClick={() =>
                                        handleDropDownActionsClick(value.action)
                                      }
                                    >
                                      {value.label}
                                    </DropdownItem>
                                  </>
                                ))}
                              </DropdownMenu>
                            </Dropdown>
                          </>
                        </>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="12">
                              {userData?.detail_fx_ticket?.["Requête"] ? (
                                <RequestCard
                                  title="Requête"
                                  details={
                                    userData?.detail_fx_ticket?.["Requête"]
                                  }
                                />
                              ) : null}
                            </Col>
                            <Col sm="12">
                              <Row>
                                {userData?.detail_fx_ticket?.[
                                  "Fil de discussion"
                                ] ? (
                                  <DiscussionThread
                                    messages={
                                      userData?.detail_fx_ticket?.[
                                        "Fil de discussion"
                                      ]
                                    }
                                  />
                                ) : null}
                              </Row>
                            </Col>
                            <Row>
                              {userData?.detail_fx_ticket?.["Réponse"] ? (
                                <ReponseCard
                                  title="Réponse"
                                  onChange={handleFichierChange}
                                  onChangeText={handleReponseChange}
                                  handleReponseSubmit={handleReponseSubmit}
                                />
                              ) : null}
                            </Row>

                            <Row>
                              <Col sm="12">
                                {" "}
                                {userData?.detail_fx_ticket?.Suivi ? (
                                  <AuditCard
                                    title="Suivi"
                                    details={userData?.detail_fx_ticket?.Suivi}
                                  />
                                ) : null}
                              </Col>
                            </Row>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default TicketDetail;
